import Request from '../Request.utils'
export interface IListRequestQuery {}
export interface IUpsertRequestBody {
  id: string;
  price?: number | null;
  priceYearPair?: number | null;
  priceYearPairSpecial?: number | null;
}

class QuyUocAPI {
  list = async (query: IListRequestQuery) => {
    const res = await Request.call('/api/quy-uoc', 'GET', undefined, query, undefined, );
    return res;
  }
  upsert = async (body: IUpsertRequestBody) => {
    const res = await Request.call('/api/quy-uoc', 'POST', undefined, undefined, body, );
    return res;
  }
}
export default new QuyUocAPI()